exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box-shadow[data-v-27ef3ade] {\n  -webkit-box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n          box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n  border-top: 1px solid #E0E1E2 !important;\n}\n", ""]);

// exports
